export const normalizePath = (path: string) => {
  return path.startsWith('/') ? path : `/${path}`;
};
